export enum Domain {
  AT = 'at',
  DE = 'de',
  HR = 'hr',
  IT = 'it',
  SI = 'si',
  INSTI = 'insti',
}
